// extracted by mini-css-extract-plugin
export var fileUpload = "_f0-1";
export var modalButton = "_f0-0";